module.exports = __webpack_public_path__ + "public/images/icon-share.c3a0d44ae06929959b3b6184320d6b34.svg";